// extracted by mini-css-extract-plugin
module.exports = {"component":"CustomHeader_component__eNy12","col":"CustomHeader_col__HOzM3","title":"CustomHeader_title__3n0Fw","bar":"CustomHeader_bar__2MxZn"};